// frontend/src/services/api/transactionAPI.js
import api from "./config";

const transactionAPI = {
  getTransactions: (params = {}) => api.get("/transactions", { params }),

  getTransactionDetails: (transactionId) =>
    api.get(`/transactions/${transactionId}`),

  downloadInvoice: (transactionId) =>
    api.get(`/transactions/${transactionId}/invoice`, {
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    }),
};

export default transactionAPI;
